export default "__VITE_ASSET__23759c95__"